import React from 'react';
import { ArrowRight, Play } from 'lucide-react';
interface AdvisoryHeroProps {
  openContactForm: () => void;
}
export function AdvisoryHero({
  openContactForm
}: AdvisoryHeroProps) {
  const scrollToCaseStudies = () => {
    const section = document.getElementById('case-studies');
    if (section) {
      section.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="w-full min-h-screen flex items-center relative overflow-hidden bg-navy-900" data-id="element-89">
      {/* Abstract geometric background */}
      <div className="absolute inset-0" data-id="element-90">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-navy-800/50 to-transparent" data-id="element-91" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-gold-500/5 rounded-full blur-3xl" data-id="element-92" />
        <div className="absolute top-1/4 right-1/4 w-64 h-64 bg-emerald-500/5 rounded-full blur-3xl" data-id="element-93" />
        {/* Grid pattern */}
        <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)`,
        backgroundSize: '60px 60px'
      }} data-id="element-94" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-32" data-id="element-95">
        <div className="max-w-4xl" data-id="element-96">
          {/* Eyebrow */}
          <div className="flex items-center gap-3 mb-8" data-id="element-97">
            <div className="h-px w-12 bg-gold-500" data-id="element-98" />
            <span className="text-gold-500 text-sm font-medium tracking-[0.2em] uppercase" data-id="element-99">
              Fractional CFO & M&A Advisory
            </span>
          </div>

          {/* Main headline */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-serif text-white mb-8 leading-[1.1] tracking-tight" data-id="element-100">
            Institutional-Grade Finance for the Modern SMB.
          </h1>

          {/* Sub-headline */}
          <p className="text-xl sm:text-2xl text-slate-400 mb-12 max-w-3xl leading-relaxed font-light" data-id="element-101">
            You've built a great business; now let's make it a{' '}
            <span className="text-white" data-id="element-102">durable</span> one. I provide
            fractional CFO services and strategic advisory to help small
            businesses and non-profits professionalize operations, unlock cash
            flow, and maximize enterprise value.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-103">
            <a href="https://calendar.app.google/QG1eQrZMQfAuXDhF8" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center justify-center bg-gold-500 text-navy-900 px-8 py-4 font-semibold rounded hover:bg-gold-400 transition-all duration-300 text-[15px]" data-id="element-104">
              Schedule Your Free Discovery Call Today
              <ArrowRight size={18} className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-105" />
            </a>

            <button onClick={scrollToCaseStudies} className="group inline-flex items-center justify-center bg-transparent border border-slate-600 text-white px-8 py-4 font-medium rounded hover:border-slate-400 hover:bg-white/5 transition-all duration-300 text-[15px]" data-id="element-106">
              <Play size={16} className="mr-2" data-id="element-107" />
              View Performance Case Studies
            </button>
          </div>
        </div>

        {/* Stats bar */}
        <div className="mt-20 pt-12 border-t border-slate-800" data-id="element-108">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-109">
            {[{
            value: '$10M+',
            label: 'Capital Secured'
          }, {
            value: '$20M+',
            label: 'Assets Optimized'
          }, {
            value: 'CFA®',
            label: 'Charterholder'
          }, {
            value: '6.5+',
            label: 'Years PE Experience'
          }].map((stat, index) => <div key={index} data-id="element-110">
                <div className="text-3xl sm:text-4xl font-serif text-gold-500 mb-2" data-id="element-111">
                  {stat.value}
                </div>
                <div className="text-slate-500 text-sm" data-id="element-112">{stat.label}</div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}